<template>
  <div class="photos2">
    <el-tabs v-model="activeName">
      <el-tab-pane
        :key="activeName"
        :label="'现场照片'"
        :name="activeName + ''"
      >
        <div class="insurancePhotos">
          <!-- 其他证据 -->
          <div
            v-for="photo in InsuranceList"
            :key="photo.photoUrl"
            class="photo-wrapper"
          >
            <span class="required-name3">证据采集</span>
            <img
              class="el-icon-close delete-photo"
              @click="deletePhoto(photo.photoUrl)"
              src="@/assets/images/accident/delete.png"
            />
            <el-image
              class="accident-image"
              :src="photo.photoUrl"
              :preview-src-list="previewSrcList"
            >
              <template #error>
                <div
                  class="capture"
                  :style="{
                    cursor: isDisabled.value
                      ? currentRole === '保险员'
                        ? 'pointer'
                        : 'not-allowed'
                      : 'pointer'
                  }"
                >
                  <i class="el-icon-loading" style="font-size: 22px" />
                </div>
              </template>
            </el-image>
          </div>
          <div>
            <div
              class="capture"
              :style="{
                cursor: isDisabled.value
                  ? currentRole === '保险员'
                    ? 'pointer'
                    : 'not-allowed'
                  : 'pointer'
              }"
              @click="addPhoto('新增照片')"
            >
              点击拍照截图
            </div>
          </div>
        </div>
      </el-tab-pane>
      <div class="saveBtn">
        <span class="partyBtn btn1" @click="savePhoto"> 保存照片 </span>
        <span class="partyBtn btn2" @click="downPhoto"> 下载证据 </span>
      </div>
    </el-tabs>
  </div>
</template>

<script>
import { upload } from "@/api/common/upload";
import { saveInsuranceAccidentPhotoList } from "@/api/accident/edit";
import { downLoadZip } from "@/utils/zipdownload";
export default {
  inject: {
    targetRefs: { default: null },
    isDisabled: { default: () => ({ value: false }) }
  },
  props: {
    isInsurance: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeName: 0,
      InsuranceList: []
    };
  },
  computed: {
    previewSrcList() {
      const list = this.InsuranceList.map(el => {
        return el["photoUrl"];
      });
      return list;
    },
    currentRole() {
      return this.$store.getters.accidentRoleName;
    }
  },
  watch: {
    isInsurance: {
      handler(val) {
        const list = val.filter(({ type }) => type == this.activeName);
        if (list && list.length) {
          const newList = list[0].photoUrl && list[0].photoUrl.split(",");
          newList.length &&
            newList.forEach(el => {
              const obj = {};
              obj.photoUrl = el;
              obj.type = list[0].type;
              obj.photoName = list[0].photoName;
              this.InsuranceList.push(obj);
            });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    addPhoto(photoName = "新增图片") {
      if (this.isDisabled.value && this.currentRole !== "保险员") {
        return;
      }
      if (this.isInsurance.length >= 50) {
        this.$message.warning("截图数量达到上限");
        return;
      }
      const newPhoto = {
        photoUrl: "",
        photoName,
        type: this.activeName
      };
      this.targetRefs.video
        .screenShot()
        .then(base64Str => upload({ fileName: "xxx.png", base64Str }))
        .then(({ data }) => {
          newPhoto.photoUrl = data;
          this.InsuranceList.push(newPhoto);
          console.log(666, this.InsuranceList);
        })
        .catch(() => {
          console.log(777);
          this.InsuranceList.splice(
            this.InsuranceList.findIndex(item => item === newPhoto),
            1
          );
        });
    },
    deletePhoto(url) {
      this.InsuranceList.splice(
        this.InsuranceList.findIndex(({ photoUrl }) => photoUrl === url),
        1
      );
    },
    savePhoto() {
      const accidentId = this.$route.params.id;
      const urls =
        this.InsuranceList.length &&
        this.InsuranceList.map(el => {
          return el.photoUrl;
        }).join(",");
      console.log(8888);
      saveInsuranceAccidentPhotoList(urls, accidentId).then(res => {
        if (res.code === 0) {
          this.$message.success("保存成功");
        }
      });
    },
    downPhoto() {
      const accidentId = this.$route.params.id;
      downLoadZip(`/insurancePhoneDownload?accidentId=${accidentId}`);
    }
  }
};
</script>

<style lang="scss">
.photos2 {
  height: 400px;
  margin-top: 65px;
  overflow-y: auto;
  .el-tabs__header {
    display: none;
  }
  .insurancePhotos {
    display: flex;
    flex-wrap: wrap;
  }
  .photo-wrapper {
    width: 220px;
    height: 140px;
    margin: 0 40px 40px;
    position: relative;
    .required-name3 {
      position: absolute;
      left: -25px;
      top: 8px;
      height: 100%;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #17ecfe;
      letter-spacing: 1px;
      writing-mode: tb-rl;
    }
    .accident-image {
      width: 220px;
      height: 140px;
      border-radius: 2px;

      .required-upload {
        background: rgba(0, 0, 0, 0.04);
        font-size: 16px;
        color: #226eff;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .photo-name-input {
      .el-input__inner {
        border: none;
        padding: 0;
        text-align: center;
        cursor: default;

        &:focus {
          border: 1px solid #020202;
          cursor: text;
        }
      }
    }

    .delete-photo {
      cursor: pointer;
      display: none;
      position: absolute;
      right: 5px;
      top: 5px;
      font-weight: 500;
      font-size: 22px;
      z-index: 10;
      color: #ff4949;
    }
    position: relative;

    &:hover {
      .delete-photo {
        display: block;
      }
    }
  }
  .capture {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 140px;
    background: #0b2756;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 400;
    color: #226eff;
    margin: -2px 0 20px 40px;
  }
}
.saveBtn {
  width: 100%;
  margin-left: 40px;
  margin-bottom: 50px;
  text-align: left;
  .partyBtn {
    display: inline-block;
    width: 160px;
    height: 48px;
    line-height: 48px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }
  .btn1 {
    color: #0ebd35;
    background: rgba(14, 189, 53, 0.1);
    border: 1px solid #0ebd35;
    margin-right: 15px;
  }
  .btn2 {
    color: #ff7d00;
    background: rgba(255, 125, 0, 0.1);
    border: 1px solid #ff7d00;
  }
}
</style>
